import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import * as Sentry from '@sentry/browser';
import {useHistory} from 'react-router-dom';
import {MissionControlHeader_viewer} from './__generated__/MissionControlHeader_viewer.graphql';
import {useSingleton} from '../../../forecast-app/shared/hooks/useSingleton';

function goto(url: string, history): void {
	history.push(url);
}

function getButton(url: string, text: string, index: number, history): JSX.Element {
	const currentUrl = window.location.pathname;
	return (
		<button key={index} className={'tab' + (url === currentUrl ? ' selected' : '')} onClick={() => goto(url, history)}>
			{text}
		</button>
	);
}

interface MissionControlHeaderProps {
	viewer: MissionControlHeader_viewer;
}

function MissionControlHeader({viewer}: MissionControlHeaderProps): JSX.Element {
	useSingleton(() => {
		Sentry.configureScope(scope => {
			scope.setUser({
				email: viewer.email || undefined,
				id: atob(viewer.actualPersonId || '').replace('Person:', ''),
				company_id: atob(viewer.company?.id || '').replace('Company:', ''),
				name: viewer.firstName + ' ' + viewer.lastName,
				company_name: viewer.company?.name,
			});
		});
	}, []);

	const history = useHistory();

	const urls = [
		'',
		'/company-stats',
		'/trials',
		'/companies-with-modules',
		'/person-list',
		'/features',
		'/ml-stats',
		'/restore-data',
		'/sage-signup',
	];
	const texts = [
		'Impersonate',
		'Company stats',
		'Trials',
		'Modules',
		'Person list',
		'Feature Flags',
		'ML Stats',
		'Restore Data',
		'Sage Signup',
	];
	const prefix = window.location.pathname.includes('missioncontrol') ? '/missioncontrol' : '/control';
	return (
		<div className="mission-control-header">
			{urls.map((url, index) => getButton(prefix + url, texts[index], index, history))}
		</div>
	);
}

export default createFragmentContainer(MissionControlHeader, {
	viewer: graphql`
		fragment MissionControlHeader_viewer on Viewer {
			email
			actualPersonId
			firstName
			lastName
			company {
				id
				name
			}
		}
	`,
});
